import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query"

import { http } from "@/lib/http"
import { qk } from "@/lib/query-keys"

import type { ClientId, UserId } from "../clients-data"

import type { ClientOutWire } from "./clients"

interface ClientMemberInWire {
  user_id: number
  is_primary: boolean
}

export async function addClientMember(clientId: ClientId, userId: UserId): Promise<void> {
  const path = `/api/v1/clients/${clientId}/members`

  const body: ClientMemberInWire = {
    user_id: Number(userId),
    is_primary: false,
  }

  await http.post<ClientOutWire, ClientMemberInWire>(path, body)
}

export async function removeClientMember(clientId: ClientId, userId: UserId): Promise<void> {
  const path = `/api/v1/clients/${clientId}/members/${userId}`

  await http.delete(path)
}

export interface MemberChange {
  clientId: ClientId
  userId: UserId
}

export function useAddClientMemberMutation(): UseMutationResult<void, Error, MemberChange> {
  const queryClient = useQueryClient()

  const mutator = (change: MemberChange) => {
    return addClientMember(change.clientId, change.userId)
  }

  const successCallback = () => {
    void queryClient.invalidateQueries({ queryKey: qk.clients.all })
  }

  return useMutation({ mutationFn: mutator, onSuccess: successCallback })
}

export function useRemoveClientMemberMutation(): UseMutationResult<void, Error, MemberChange> {
  const queryClient = useQueryClient()

  const mutator = (change: MemberChange) => {
    return removeClientMember(change.clientId, change.userId)
  }

  const successCallback = () => {
    void queryClient.invalidateQueries({ queryKey: qk.clients.all })
  }

  return useMutation({ mutationFn: mutator, onSuccess: successCallback })
}
